import './itemInfo.scss';
import React, { useRef } from 'react';
import Table from '../table/Table';
import Helpers from '../../js/helpers';
import { useTranslation } from 'react-i18next';
import Flag from '../flag/Flag';
import globeIcon from '@icons/languages-small.svg';
import { AI_CLASSIFICATION, AI_HUMAN_REVIEWED } from '../../js/_constants';

const ItemInfo = ({
    data,
    info
}) => {
    const { t } = useTranslation();

    const ref = useRef(null);

    const renderFlags = countries =>
        countries.map(country => { 
            const countrySplit = country.split('/');
            // ex  "/countries/DEU"
            return <Flag key={countrySplit[2]} country={countrySplit[2]} />
            });

    const renderCountries = countries =>
        countries[0] === '???' ? (
            <img src={globeIcon} className="glob-icon" />
        ) : (
            renderFlags(countries)
        );

    // build prop for table: array of arrays [key, value], 'key' for row title and 'value' for row content
    const buildItemInfo = () => {
        const { description, language, sharedCountries, kvps, aiCompliance } = data;

        const type = data['@type']

        const { fileSize, tags } = info;

        const result: [string, any][] = [];

        const add = (key, value) => result.push([key, value]);

        add('item_tags', tags);

        description
            ? add('description', description)
            : add('description', t('no_description'));

        type.toLowerCase() === 'video'
            ? add('item_video_language', language.toUpperCase())
            : add('item_language', language.toUpperCase());

        add(
            'file_size',
            `${Helpers.bytesToSize(fileSize || data.fileInfo.fileSize)}`
        );

        sharedCountries &&
        sharedCountries.length > 0 &&
            add('available_countries', renderCountries(sharedCountries));

        kvps &&
        kvps.length > 0 &&
            add('dealer_content', kvps.join(', '));
        
        aiCompliance &&
        aiCompliance.classification &&
            add('ai_classification', AI_CLASSIFICATION.find(item => item.value === aiCompliance.classification)?.label || t('unknown'));
        
        aiCompliance &&
        aiCompliance.humanReviewed !== undefined &&
            add('ai_human_reviewed', AI_HUMAN_REVIEWED.find(item => item.value === aiCompliance.humanReviewed)?.label || t('unknown'));

        return result;
    };

    return (
        <div ref={ref} className="b-item-info">
            <Table data={buildItemInfo()} />
        </div>
    );
};

export default ItemInfo;
